import * as React from 'react';
import { IFullPaginationOptions } from './pagination';

export interface IPagingArrowsProps {
    paging: IFullPaginationOptions;
    isLeftArrows: boolean;
    onPageSelect(page: number): void;
}

/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export class PagingArrows extends React.Component<IPagingArrowsProps, any> {

    /// <summary>
    /// Calculates left or right page arrow content
    /// </summary>
    /// <returns>Left or right arrow JSX content</returns>
    GetResult() {
        if (this.props.paging.totalItems === 0) return null;

        const numberOfPages = this.props.paging.totalPages;

        if (this.props.isLeftArrows) {
            const isDisabled = this.props.paging.currentPage === 1;
            const classNames = "search-pagination-arrows search-pagination-arrows-left" + (isDisabled ? " search-pagination-arrows-disabled" : "");
            return (
                <div className={classNames}>
                    <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(1) }>
                        <svg>
                            <use xlinkHref="#arrow-double-left"></use>
                        </svg>
                        <p className="visually-hidden">First</p>
                    </div>
                    <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(this.props.paging.currentPage - 1) }>
                        <svg>
                            <use xlinkHref="#arrow-left"></use>
                        </svg>
                        <p className="visually-hidden">Previous</p>
                    </div>
                </div>
            );
        }
        else {
            const isDisabled = this.props.paging.currentPage === numberOfPages;
            const classNames = "search-pagination-arrows search-pagination-arrows-right" + (isDisabled ? " search-pagination-arrows-disabled" : "");
            return (
                <div className={classNames}>
                    <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(this.props.paging.currentPage + 1) }>
                        <p className="visually-hidden">Next</p>
                        <svg>
                            <use xlinkHref="#arrow-right"></use>
                        </svg>
                    </div>
                    <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(numberOfPages) }>
                        <p className="visually-hidden">Last</p>
                        <svg>
                            <use xlinkHref="#arrow-double-right"></use>
                        </svg>
                    </div>
                </div>
            );
        }
    }

    render() {
        return this.GetResult();
    }
}